/** Every word the visit host draws (C1). Areas name their own subjects. */
export const visitCopy = {
  back: (origin: string) => (origin ? `Back to ${origin}` : "Back"),
  trail: "Where you are",
  refusedHeading: "This isn't available",
  refusedSentence: "You can't open this here, or it couldn't be read.",
} as const;
